import React, { FC } from 'react';
import { graphql, HeadFC, PageProps } from 'gatsby';

import Layout from '../components/Layout';
import Home from '../views/Home';
import SEO from '../components/Head';

import { PageContext } from '../../gatsby-node';

const Page: FC<PageProps<Queries.HomePageQuery, PageContext>> = props => {
  const {
    pageContext: { locale },
    data,
  } = props;

  return (
    <Layout>
      <Home data={data} locale={locale} showLoginWidget />
    </Layout>
  );
};

export const Head: HeadFC<Queries.HomePageQuery, PageContext> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query HomePage($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...SeoHeaderHome
        ...SeoWhyHome
        ...SeoGuide
        ...SeoReadytoGetStarted
        ...SeoFooter
      }
    }
  }
`;

export default Page;
